export const REMINDER_DIALOG_NAME = 'SendReminder';
